const validGoogleSymbols = [
    'accessible',
    'account_balance',
    'account_box',
    'account_tree',
    'add',
    'add_circle',
    'airline_seat_legroom_extra',
    'airline_seat_legroom_normal',
    'airline_seat_legroom_reduced',
    'airline_seat_recline_extra',
    'airline_seat_recline_normal',
    'airport_shuttle',
    'api',
    'app_registration',
    'apps',
    'apps_outage',
    'architecture',
    'arrow_back',
    'arrow_downward',
    'arrow_drop_down',
    'arrow_forward',
    'arrow_upward',
    'article',
    'assessment',
    'assignment',
    'assignment_add',
    'attach_money',
    'attractions',
    'auto_transmission',
    'bar_chart',
    'beach_access',
    'bed',
    'bid_landscape',
    'bookmark',
    'bookmark_add',
    'box_edit',
    'bug_report',
    'build',
    'business_center',
    'cached',
    'calendar_clock',
    'calendar_month',
    'call',
    'call_end',
    'cancel',
    'car_crash',
    'car_rental',
    'carry_on_bag',
    'casino',
    'chat',
    'check',
    'check_box',
    'check_box_outline_blank',
    'check_circle',
    'check_indeterminate_small',
    'checked_bag',
    'chevron_left',
    'chevron_right',
    'child_care',
    'chronic',
    'circle',
    'close',
    'closed_caption',
    'closed_caption_off',
    'cloud',
    'compare_arrows',
    'connecting_airports',
    'content_copy',
    'corporate_fare',
    'contacts',
    'credit_card',
    'currency_exchange',
    'cycle',
    'dashboard',
    'database',
    'database_search',
    'database_upload',
    'date_range',
    'delete',
    'delete_sweep',
    'deployed_code',
    'deployed_code_account',
    'deployed_code_alert',
    'deployed_code_history',
    'deployed_code_update',
    "description",
    'developer_board',
    'devices',
    'dialpad',
    'directions_boat',
    'directions_car',
    'directions_subway',
    'distance',
    'domain',
    'eco',
    'edit',
    'editor_choice',
    'email',
    'error',
    'event',
    'event_seat',
    'expand_less',
    'expand_more',
    'explore',
    'family_restroom',
    'favorite',
    'favorite_border',
    'featured_seasonal_and_gifts',
    'file_copy',
    'filter_list',
    'first_page',
    'fitness_center',
    'flash_on',
    'flight',
    'flight_land',
    'flight_takeoff',
    'fork_spoon',
    'format_quote',
    'free_cancellation',
    'fullscreen',
    'fullscreen_exit',
    'group',
    'groups',
    'heart_plus',
    'help',
    'hiking',
    'history',
    'home',
    'home_work',
    'hot_tub',
    'hotel',
    'hub',
    'id_card',
    'image',
    'info',
    'integration_instructions',
    'key',
    'keyboard_arrow_down',
    'kitchen',
    'language',
    'laptop_mac',
    'last_page',
    'layers',
    'leaderboard',
    'link',
    'list',
    'list_alt',
    'local_activity',
    'local_bar',
    'local_cafe',
    'local_dining',
    'local_parking',
    'local_see',
    'local_taxi',
    'location_city',
    'location_on',
    'lock',
    'login',
    'logout',
    'luggage',
    'mail',
    'manage_accounts',
    'manage_search',
    'map',
    'medical_services',
    'menu',
    'menu_open',
    'merge',
    'mic',
    'mic_off',
    'microwave',
    'monitoring',
    'moon_stars',
    'more_horiz',
    'more_vert',
    'motion_photos_auto',
    'museum',
    'my_location',
    'network_node',
    'north',
    'open_in_new',
    'oven',
    'paid',
    'park',
    'pause',
    'payments',
    'person',
    'person_check',
    'pets',
    'phone',
    'phone_callback',
    'phone_forwarded',
    'phone_missed',
    'photo_library',
    'pin_drop',
    'play_arrow',
    'policy',
    'pool',
    'priority_high',
    'progress_activity',
    'question_mark',
    'radio_button_checked',
    'radio_button_unchecked',
    'release_alert',
    'refresh',
    'remove',
    'remove_circle',
    'restaurant',
    'road',
    'route',
    'schedule',
    'search',
    'security',
    'sell',
    'settings',
    'share',
    'shoppingmode',
    'show_chart',
    'smoke_free',
    'sort',
    'swap_calls',
    'south',
    'spa',
    'speed',
    'stadium',
    'star',
    'store',
    'storefront',
    'support_agent',
    'swap_horiz',
    'sync',
    'task_alt',
    'team_dashboard',
    'theater_comedy',
    'thermostat',
    'thumb_down',
    'thumb_up',
    'time_to_leave',
    'track_changes',
    'travel_explore',
    'travel_luggage_and_bags',
    'trending_up',
    'trip',
    'trophy',
    'tune',
    'unfold_more',
    'verified',
    'verified_user',
    'video_library',
    'view_carousel',
    'visibility',
    'visibility_off',
    'vital_signs',
    'warning',
    'water',
    'web',
    'webhook',
    'widgets',
    'wifi',
    'work',
    'workspace_premium',
    'zoom_in',
    'zoom_out',
    'zoom_out_map'
];
export { validGoogleSymbols };
